import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function GranitePage() {
  return <ProductPageContent data={PRODUCT_PAGES["granite"]} />;
}

export default GranitePage;
